export const communicationGroups = [
  'FSLI',
  'OMV PETROM',
  'DEALERI',
  'CONTRACTORI'
]
